export default __webpack_public_path__ + "static/media/exit.54b13971.svg";